import React from "react";
import { libraryUrl } from "./util";

function Tutorial() {
  return (
    <div
      style={{
        marginLeft: 30,
        paddingTop: 10,
        position: "relative"
      }}
    >
      <img style={{ width: 40 }} src={libraryUrl("/img/arrow.png")}></img>
      <div
        style={{
          position: "absolute",
          bottom: 0,
          left: 50,
          fontSize: "105%"
        }}
      >
        Click layer name to get started
      </div>
    </div>
  );
}

export default Tutorial;
